import React from "react";

const NotFoundErrorPage = () => {
  return <div>404 page</div>;
};

export default NotFoundErrorPage;
